import { Badge, Button, Dropdown } from "antd";
import moment from "moment";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import NotificationIcon from "../../../assets/icons/NotificationIcon";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import colors from "../../../constants/colors";
import {
  useGetAllNotificationQuery,
  useNotificationStatusMutation,
} from "../../../features/organization/notificatons/notificationApi";
import useError from "../../../hooks/useError";
import useFirebaseNotification from "../../../hooks/useFirebaseNotification";
import CustomEmpty from "../../ui/CustomEmpty";
import Loader from "../../ui/Loader";

export default function NotificationMenu() {
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(false);
  const { user } = useAppSelector((state) => state.auth);
  const { isError, error, isLoading, data, refetch } =
    useGetAllNotificationQuery({
      params: {
        business_id: user?.business_id,
      },
    });
  const [
    notificationStatus,
    { isLoading: isUpdateLoading, isError: isUpdateError, error: updateError },
  ] = useNotificationStatusMutation();
  useError(isError, error, "Notification get fail");
  useError(isUpdateError, updateError, "Notification read fail");
  const { contextHolder } = useFirebaseNotification(refetch);

  const notifications = data?.data?.notifications;

  return (
    <>
      {contextHolder}
      <Dropdown
        trigger={["click"]}
        placement="bottomRight"
        arrow={{ pointAtCenter: true }}
        open={openDropdown}
        onOpenChange={setOpenDropdown}
        dropdownRender={() => (
          <div className="w-72 bg-white shadow rounded-md">
            <div className="flex items-center justify-between gap-2 py-1.5 px-3 shadow-sm shadow-gray-100 sticky top-0">
              <span className="text-xs text-header font-medium">
                Notifications
              </span>
              {notifications?.length ? (
                <Link
                  className="text-xs text-body font-medium hover:text-header"
                  to="/organization/notification"
                  onClick={() => setOpenDropdown(false)}
                >
                  View All
                </Link>
              ) : null}
            </div>

            <div>
              <div className="h-56 overflow-y-auto notification">
                {isLoading ? (
                  <Loader />
                ) : notifications?.length ? (
                  notifications?.map((el: any) => {
                    return (
                      <div
                        className={`mb-1.5 cursor-pointer ${
                          el?.status === "unread" ? "bg-light/30" : ""
                        }`}
                        key={el?.id}
                        onClick={() => {
                          if (!isUpdateLoading) {
                            if (el?.status === "unread") {
                              notificationStatus({
                                ids: [el?.id],
                              });
                            }

                            if (
                              el?.target_type === "proposal" &&
                              el?.target_id
                            ) {
                              navigate(
                                `/organization/proposals/details/${el?.target_id}`
                              );
                            } else if (
                              el?.target_type === "project" &&
                              el?.target_id
                            ) {
                              navigate(
                                `/organization/my-projects/details/${el?.target_id}`
                              );
                            }

                            setTimeout(() => setOpenDropdown(false), 0);
                          }
                        }}
                      >
                        <div className="grid grid-cols-50 gap-1.5 py-1.5 pl-1.5">
                          <div className="flex justify-center">
                            <img
                              className="w-10 h-10 object-cover rounded-full"
                              src={el?.img || PLACEHOLDER_IMG}
                              alt=""
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <div className="relative -top-0.5">
                              <h6 className="text-body text-sm font-medium mb-1">
                                {el?.log_msg}
                              </h6>

                              <div className="text-[#7d88f4] text-xs font-normal leading-normal break-all">
                                {moment
                                  .utc(el?.created_at)
                                  .local()
                                  .format("DD MMM")}{" "}
                                {moment
                                  .utc(el?.created_at)
                                  .local()
                                  .format("hh:mm a")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <CustomEmpty
                    rootClassName="pt-10"
                    styles={{ image: { height: 100 } }}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      >
        <Badge
          count={data?.data?.total_unread || 0}
          color={colors.danger.color}
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: 500,
            left: 3,
            top: 3,
          }}
          className="!leading-none"
          // showZero
        >
          <Button
            className="border-none relative top-0.5"
            icon={<NotificationIcon />}
            size="middle"
          />
        </Badge>
      </Dropdown>
    </>
  );
}
